/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

export interface FilterDeviceModelsDto {
  /** List of device types (UUIDs) */
  deviceType?: string[];
  /** List of device maker UUIDs */
  deviceMaker?: string[];
  /** Search query string */
  query?: string;
}
